export default __webpack_public_path__ + "static/media/Bb1.47ffd71c.mp3";